import { formatUrl } from 'url-lib';

import { fetchJSON } from 'js-utils/http';
import { keysCamelToSnake } from 'js-utils/transformation';

import { SEARCH_AUTOCOMPLETE_SUGGESTIONS_URL } from '../../constants/constants';

export const searchAutocompleteSuggestions = ({
    placeId,
    onlineEventsOnly,
    query,
}) => {
    let queryParams = {
        placeId,
        q: query,
        completionTypes: ['event', 'query'],
        'expand.destination_event': ['primary_venue', 'image'],
    };

    if (onlineEventsOnly) {
        queryParams.onlineEventsOnly = true;
    }

    queryParams = keysCamelToSnake(queryParams);
    return (
        fetchJSON(formatUrl(SEARCH_AUTOCOMPLETE_SUGGESTIONS_URL, queryParams))
            // Swallow errors by logging to console. The feature still works correctly when an error occurs, so
            // we don't necessarily want to bother the user with a message, they should just be able to keep typing.
            // eslint-disable-next-line no-console
            .catch((err) => console.error(err))
    );
};
